<!--
 * @Description: 活动中心作品审核
 * @Author: liuwp
 * @Date: 2022-10-20 14:33:19
 * @LastEditors: liuwp
 * @LastEditTime: 2022-10-20 17:58:16
-->
<template>
  <div class="yxtbiz-ac-work-audit">
    <div class="standard-size-16 color-gray-10">
      <div class="mb32 font-bolder">
        {{ $t('pc_biz_ac_enroller_info' /** 申请人信息 */) }}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroller_name' /** 姓名 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-user-name :name="detail.userName" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-user-name :name="detail.userName" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroller_dept' /**  部门 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-dept-name :name="detail.deptName" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-dept-name :name="detail.deptName" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="font-normal font-size-14">
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroller_possion' /**岗位 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-position-name :name="detail.position" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-position-name :name="detail.position" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      </div>
      <div class="mb32 font-bolder">
        {{ $t('pc_biz_ac_enroll_acinfo' /** 活动信息 */) }}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroll_acname' /** 活动名称 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="detail.projectName"
              placement="top">
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">{{ detail.actName }}</div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      </div>
      <div class="mb32 font-bolder">
        {{ $t('pc_biz_ac_work_name' /** 作品信息 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_work_info' /** 作品简介 */)}}：</span>
            <span v-html="lineWrapResolve(detail.introduction)" />
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="mh2 flex">
            <yxt-button type="text" @click="viewDetails">{{ $t('pc_biz_ac_work_view_info' /** 查看作品详情 */)}}</yxt-button>
          </yxtf-col>
        </yxtf-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getWorkDetailApi } from './service';
export default {
  name: 'YxtbizAcWorkAudit',
  name_zh: '活动作品审核',
  props: {
    id: {
      type: String,
      default: '',
      desc: '报名id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      detail: {
        id: null,
        actId: null, // 活动id
        actName: null, // 活动名称
        deptName: null, // 部门
        introduction: null, // 活动信息
        position: null, // 岗位
        userName: null, // 申请人
        transcodeStatus: 0 // 转码状态
      }
    };
  },
  created() {
    this.getWorkDetail();
  },
  methods: {
    // 多行文本折行处理
    lineWrapResolve(content) {
      if (content) {
        // 去掉所有的换行符
        content = content.replace(/\r\n/g, '<br />');
        content = content.replace(/\r/g, '<br />');
        content = content.replace(/\n/g, '<br />');
      }
      return content;
    },
    // 获取作品详情
    getWorkDetail() {
      getWorkDetailApi(this.id).then(res => {
        this.detail = res;
      });
    },
    // 跳转作品详情页
    viewDetails() {
      const { transcodeStatus, actId } = this.detail;
      if (transcodeStatus === 2) {
        window.open(`${location.origin}/ac/#/work?worksId=${this.id}&id=${actId}&from=4`);
      } else if (transcodeStatus === 1) {
        this.$message.warning(this.$t('pc_biz_ac_work_tip_transcoding' /** 作品转码中，无法查看 */));
      } else if (transcodeStatus === 0) {
        this.$message.warning(this.$t('pc_biz_ac_work_tip_transcode_fail' /** 作品转码失败，无法查看 */));
      }
    }
  }
};
</script>
